// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file identities/v1/frontegg.proto (package identities.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { StructJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file identities/v1/frontegg.proto.
 */
export const file_identities_v1_frontegg: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_google_protobuf_struct],
	);

/**
 * @generated from message identities.v1.EventData
 */
export type EventData = Message<"identities.v1.EventData"> & {
	/**
	 * @generated from field: identities.v1.Claims claims = 1;
	 */
	claims?: Claims | undefined;
};

/**
 * @generated from message identities.v1.EventData
 */
export type EventDataJson = {
	/**
	 * @generated from field: identities.v1.Claims claims = 1;
	 */
	claims?: ClaimsJson;
};

/**
 * Describes the message identities.v1.EventData.
 * Use `create(EventDataSchema)` to create a new message.
 */
export const EventDataSchema: GenMessage<EventData, { jsonType: EventDataJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 0);

/**
 * @generated from message identities.v1.JWTPrehookRequest
 */
export type JWTPrehookRequest = Message<"identities.v1.JWTPrehookRequest"> & {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey: string;

	/**
	 * @generated from field: identities.v1.Context prehook_context = 2;
	 */
	prehookContext?: Context | undefined;

	/**
	 * @generated from field: identities.v1.EventData data = 3;
	 */
	data?: EventData | undefined;
};

/**
 * @generated from message identities.v1.JWTPrehookRequest
 */
export type JWTPrehookRequestJson = {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey?: string;

	/**
	 * @generated from field: identities.v1.Context prehook_context = 2;
	 */
	prehookContext?: ContextJson;

	/**
	 * @generated from field: identities.v1.EventData data = 3;
	 */
	data?: EventDataJson;
};

/**
 * Describes the message identities.v1.JWTPrehookRequest.
 * Use `create(JWTPrehookRequestSchema)` to create a new message.
 */
export const JWTPrehookRequestSchema: GenMessage<JWTPrehookRequest, { jsonType: JWTPrehookRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 1);

/**
 * @generated from message identities.v1.SignupContext
 */
export type SignupContext = Message<"identities.v1.SignupContext"> & {
	/**
	 * @generated from field: string tenant_id = 1;
	 */
	tenantId: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;

	/**
	 * @generated from field: string referer = 3;
	 */
	referer: string;
};

/**
 * @generated from message identities.v1.SignupContext
 */
export type SignupContextJson = {
	/**
	 * @generated from field: string tenant_id = 1;
	 */
	tenantId?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;

	/**
	 * @generated from field: string referer = 3;
	 */
	referer?: string;
};

/**
 * Describes the message identities.v1.SignupContext.
 * Use `create(SignupContextSchema)` to create a new message.
 */
export const SignupContextSchema: GenMessage<SignupContext, { jsonType: SignupContextJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 2);

/**
 * @generated from message identities.v1.PrehookSignupRequest
 */
export type PrehookSignupRequest = Message<"identities.v1.PrehookSignupRequest"> & {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey: string;

	/**
	 * @generated from field: identities.v1.SignupContext prehook_context = 2;
	 */
	prehookContext?: SignupContext | undefined;

	/**
	 * @generated from field: identities.v1.SignupData data = 3;
	 */
	data?: SignupData | undefined;
};

/**
 * @generated from message identities.v1.PrehookSignupRequest
 */
export type PrehookSignupRequestJson = {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey?: string;

	/**
	 * @generated from field: identities.v1.SignupContext prehook_context = 2;
	 */
	prehookContext?: SignupContextJson;

	/**
	 * @generated from field: identities.v1.SignupData data = 3;
	 */
	data?: SignupDataJson;
};

/**
 * Describes the message identities.v1.PrehookSignupRequest.
 * Use `create(PrehookSignupRequestSchema)` to create a new message.
 */
export const PrehookSignupRequestSchema: GenMessage<PrehookSignupRequest, { jsonType: PrehookSignupRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 3);

/**
 * @generated from message identities.v1.SignupUser
 */
export type SignupUser = Message<"identities.v1.SignupUser"> & {
	/**
	 * @generated from field: string email = 1;
	 */
	email: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: optional string phone_number = 3;
	 */
	phoneNumber?: string | undefined;

	/**
	 * @generated from field: optional string provider = 4;
	 */
	provider?: string | undefined;

	/**
	 * @generated from field: string metadata = 5;
	 */
	metadata: string;

	/**
	 * @generated from field: string ip_address = 6;
	 */
	ipAddress: string;
};

/**
 * @generated from message identities.v1.SignupUser
 */
export type SignupUserJson = {
	/**
	 * @generated from field: string email = 1;
	 */
	email?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: optional string phone_number = 3;
	 */
	phoneNumber?: string;

	/**
	 * @generated from field: optional string provider = 4;
	 */
	provider?: string;

	/**
	 * @generated from field: string metadata = 5;
	 */
	metadata?: string;

	/**
	 * @generated from field: string ip_address = 6;
	 */
	ipAddress?: string;
};

/**
 * Describes the message identities.v1.SignupUser.
 * Use `create(SignupUserSchema)` to create a new message.
 */
export const SignupUserSchema: GenMessage<SignupUser, { jsonType: SignupUserJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 4);

/**
 * @generated from message identities.v1.SignupTenant
 */
export type SignupTenant = Message<"identities.v1.SignupTenant"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;
};

/**
 * @generated from message identities.v1.SignupTenant
 */
export type SignupTenantJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;
};

/**
 * Describes the message identities.v1.SignupTenant.
 * Use `create(SignupTenantSchema)` to create a new message.
 */
export const SignupTenantSchema: GenMessage<SignupTenant, { jsonType: SignupTenantJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 5);

/**
 * @generated from message identities.v1.SignupData
 */
export type SignupData = Message<"identities.v1.SignupData"> & {
	/**
	 * @generated from field: identities.v1.SignupUser user = 1;
	 */
	user?: SignupUser | undefined;

	/**
	 * @generated from field: identities.v1.SignupTenant tenant = 7;
	 */
	tenant?: SignupTenant | undefined;
};

/**
 * @generated from message identities.v1.SignupData
 */
export type SignupDataJson = {
	/**
	 * @generated from field: identities.v1.SignupUser user = 1;
	 */
	user?: SignupUserJson;

	/**
	 * @generated from field: identities.v1.SignupTenant tenant = 7;
	 */
	tenant?: SignupTenantJson;
};

/**
 * Describes the message identities.v1.SignupData.
 * Use `create(SignupDataSchema)` to create a new message.
 */
export const SignupDataSchema: GenMessage<SignupData, { jsonType: SignupDataJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 6);

/**
 * @generated from message identities.v1.Context
 */
export type Context = Message<"identities.v1.Context"> & {
	/**
	 * @generated from field: string tenant_id = 1;
	 */
	tenantId: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;

	/**
	 * @generated from field: string application_id = 3;
	 */
	applicationId: string;

	/**
	 * @generated from field: string referer = 4;
	 */
	referer: string;
};

/**
 * @generated from message identities.v1.Context
 */
export type ContextJson = {
	/**
	 * @generated from field: string tenant_id = 1;
	 */
	tenantId?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;

	/**
	 * @generated from field: string application_id = 3;
	 */
	applicationId?: string;

	/**
	 * @generated from field: string referer = 4;
	 */
	referer?: string;
};

/**
 * Describes the message identities.v1.Context.
 * Use `create(ContextSchema)` to create a new message.
 */
export const ContextSchema: GenMessage<Context, { jsonType: ContextJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 7);

/**
 * @generated from message identities.v1.UpdateUserContext
 */
export type UpdateUserContext = Message<"identities.v1.UpdateUserContext"> & {
	/**
	 * @generated from field: optional string tenant_id = 1;
	 */
	tenantId?: string | undefined;

	/**
	 * @generated from field: optional string user_id = 2;
	 */
	userId?: string | undefined;

	/**
	 * @generated from field: optional string referer = 3;
	 */
	referer?: string | undefined;
};

/**
 * @generated from message identities.v1.UpdateUserContext
 */
export type UpdateUserContextJson = {
	/**
	 * @generated from field: optional string tenant_id = 1;
	 */
	tenantId?: string;

	/**
	 * @generated from field: optional string user_id = 2;
	 */
	userId?: string;

	/**
	 * @generated from field: optional string referer = 3;
	 */
	referer?: string;
};

/**
 * Describes the message identities.v1.UpdateUserContext.
 * Use `create(UpdateUserContextSchema)` to create a new message.
 */
export const UpdateUserContextSchema: GenMessage<UpdateUserContext, { jsonType: UpdateUserContextJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 8);

/**
 * @generated from message identities.v1.UpdateUser
 */
export type UpdateUser = Message<"identities.v1.UpdateUser"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email: string;
};

/**
 * @generated from message identities.v1.UpdateUser
 */
export type UpdateUserJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;
};

/**
 * Describes the message identities.v1.UpdateUser.
 * Use `create(UpdateUserSchema)` to create a new message.
 */
export const UpdateUserSchema: GenMessage<UpdateUser, { jsonType: UpdateUserJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 9);

/**
 * @generated from message identities.v1.UpdateUserValues
 */
export type UpdateUserValues = Message<"identities.v1.UpdateUserValues"> & {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string | undefined;

	/**
	 * @generated from field: optional string phone_number = 2;
	 */
	phoneNumber?: string | undefined;

	/**
	 * @generated from field: optional string profile_picture_url = 3;
	 */
	profilePictureUrl?: string | undefined;

	/**
	 * @generated from field: optional string metadata = 4;
	 */
	metadata?: string | undefined;

	/**
	 * @generated from field: optional bool invisible = 5;
	 */
	invisible?: boolean | undefined;

	/**
	 * @generated from field: optional bool super_user = 6;
	 */
	superUser?: boolean | undefined;

	/**
	 * @generated from field: optional string tenant_id = 7;
	 */
	tenantId?: string | undefined;

	/**
	 * @generated from field: optional string email = 8;
	 */
	email?: string | undefined;
};

/**
 * @generated from message identities.v1.UpdateUserValues
 */
export type UpdateUserValuesJson = {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: optional string phone_number = 2;
	 */
	phoneNumber?: string;

	/**
	 * @generated from field: optional string profile_picture_url = 3;
	 */
	profilePictureUrl?: string;

	/**
	 * @generated from field: optional string metadata = 4;
	 */
	metadata?: string;

	/**
	 * @generated from field: optional bool invisible = 5;
	 */
	invisible?: boolean;

	/**
	 * @generated from field: optional bool super_user = 6;
	 */
	superUser?: boolean;

	/**
	 * @generated from field: optional string tenant_id = 7;
	 */
	tenantId?: string;

	/**
	 * @generated from field: optional string email = 8;
	 */
	email?: string;
};

/**
 * Describes the message identities.v1.UpdateUserValues.
 * Use `create(UpdateUserValuesSchema)` to create a new message.
 */
export const UpdateUserValuesSchema: GenMessage<UpdateUserValues, { jsonType: UpdateUserValuesJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 10);

/**
 * @generated from message identities.v1.UpdateUserData
 */
export type UpdateUserData = Message<"identities.v1.UpdateUserData"> & {
	/**
	 * @generated from field: identities.v1.UpdateUser user = 1;
	 */
	user?: UpdateUser | undefined;

	/**
	 * @generated from field: identities.v1.UpdateUserValues new_values = 2;
	 */
	newValues?: UpdateUserValues | undefined;
};

/**
 * @generated from message identities.v1.UpdateUserData
 */
export type UpdateUserDataJson = {
	/**
	 * @generated from field: identities.v1.UpdateUser user = 1;
	 */
	user?: UpdateUserJson;

	/**
	 * @generated from field: identities.v1.UpdateUserValues new_values = 2;
	 */
	newValues?: UpdateUserValuesJson;
};

/**
 * Describes the message identities.v1.UpdateUserData.
 * Use `create(UpdateUserDataSchema)` to create a new message.
 */
export const UpdateUserDataSchema: GenMessage<UpdateUserData, { jsonType: UpdateUserDataJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 11);

/**
 * @generated from message identities.v1.PrehookUpdateUserRequest
 */
export type PrehookUpdateUserRequest = Message<"identities.v1.PrehookUpdateUserRequest"> & {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey: string;

	/**
	 * @generated from field: identities.v1.UpdateUserContext prehook_context = 2;
	 */
	prehookContext?: UpdateUserContext | undefined;

	/**
	 * @generated from field: identities.v1.UpdateUserData data = 3;
	 */
	data?: UpdateUserData | undefined;
};

/**
 * @generated from message identities.v1.PrehookUpdateUserRequest
 */
export type PrehookUpdateUserRequestJson = {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey?: string;

	/**
	 * @generated from field: identities.v1.UpdateUserContext prehook_context = 2;
	 */
	prehookContext?: UpdateUserContextJson;

	/**
	 * @generated from field: identities.v1.UpdateUserData data = 3;
	 */
	data?: UpdateUserDataJson;
};

/**
 * Describes the message identities.v1.PrehookUpdateUserRequest.
 * Use `create(PrehookUpdateUserRequestSchema)` to create a new message.
 */
export const PrehookUpdateUserRequestSchema: GenMessage<PrehookUpdateUserRequest, { jsonType: PrehookUpdateUserRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 12);

/**
 * @generated from message identities.v1.PrehookUpdateUserResponse
 */
export type PrehookUpdateUserResponse = Message<"identities.v1.PrehookUpdateUserResponse"> & {
	/**
	 * @generated from field: bool continue = 1;
	 */
	continue: boolean;

	/**
	 * @generated from field: identities.v1.ErrMsg error = 2;
	 */
	error?: ErrMsg | undefined;
};

/**
 * @generated from message identities.v1.PrehookUpdateUserResponse
 */
export type PrehookUpdateUserResponseJson = {
	/**
	 * @generated from field: bool continue = 1;
	 */
	continue?: boolean;

	/**
	 * @generated from field: identities.v1.ErrMsg error = 2;
	 */
	error?: ErrMsgJson;
};

/**
 * Describes the message identities.v1.PrehookUpdateUserResponse.
 * Use `create(PrehookUpdateUserResponseSchema)` to create a new message.
 */
export const PrehookUpdateUserResponseSchema: GenMessage<PrehookUpdateUserResponse, { jsonType: PrehookUpdateUserResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 13);

/**
 * @generated from message identities.v1.Claims
 */
export type Claims = Message<"identities.v1.Claims"> & {
	/**
	 * @generated from field: string sub = 1;
	 */
	sub: string;

	/**
	 * @generated from field: string tenant_id = 2;
	 */
	tenantId: string;

	/**
	 * @generated from field: repeated string roles = 3;
	 */
	roles: string[];

	/**
	 * @generated from field: repeated string permissions = 4;
	 */
	permissions: string[];

	/**
	 * @generated from field: google.protobuf.Struct metadata = 5;
	 */
	metadata?: JsonObject | undefined;

	/**
	 * @generated from field: string type = 6;
	 */
	type: string;

	/**
	 * @generated from field: optional string email = 7;
	 */
	email?: string | undefined;
};

/**
 * @generated from message identities.v1.Claims
 */
export type ClaimsJson = {
	/**
	 * @generated from field: string sub = 1;
	 */
	sub?: string;

	/**
	 * @generated from field: string tenant_id = 2;
	 */
	tenantId?: string;

	/**
	 * @generated from field: repeated string roles = 3;
	 */
	roles?: string[];

	/**
	 * @generated from field: repeated string permissions = 4;
	 */
	permissions?: string[];

	/**
	 * @generated from field: google.protobuf.Struct metadata = 5;
	 */
	metadata?: StructJson;

	/**
	 * @generated from field: string type = 6;
	 */
	type?: string;

	/**
	 * @generated from field: optional string email = 7;
	 */
	email?: string;
};

/**
 * Describes the message identities.v1.Claims.
 * Use `create(ClaimsSchema)` to create a new message.
 */
export const ClaimsSchema: GenMessage<Claims, { jsonType: ClaimsJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 14);

/**
 * @generated from message identities.v1.ResponseClaims
 */
export type ResponseClaims = Message<"identities.v1.ResponseClaims"> & {
	/**
	 * @generated from field: string tenant_id = 1;
	 */
	tenantId: string;

	/**
	 * @generated from field: google.protobuf.Struct custom_claims = 2;
	 */
	customClaims?: JsonObject | undefined;
};

/**
 * @generated from message identities.v1.ResponseClaims
 */
export type ResponseClaimsJson = {
	/**
	 * @generated from field: string tenant_id = 1;
	 */
	tenantId?: string;

	/**
	 * @generated from field: google.protobuf.Struct custom_claims = 2;
	 */
	customClaims?: StructJson;
};

/**
 * Describes the message identities.v1.ResponseClaims.
 * Use `create(ResponseClaimsSchema)` to create a new message.
 */
export const ResponseClaimsSchema: GenMessage<ResponseClaims, { jsonType: ResponseClaimsJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 15);

/**
 * @generated from message identities.v1.PrehookSignupResponse
 */
export type PrehookSignupResponse = Message<"identities.v1.PrehookSignupResponse"> & {
	/**
	 * @generated from field: bool continue = 1;
	 */
	continue: boolean;

	/**
	 * @generated from field: identities.v1.ErrMsg error = 2;
	 */
	error?: ErrMsg | undefined;
};

/**
 * @generated from message identities.v1.PrehookSignupResponse
 */
export type PrehookSignupResponseJson = {
	/**
	 * @generated from field: bool continue = 1;
	 */
	continue?: boolean;

	/**
	 * @generated from field: identities.v1.ErrMsg error = 2;
	 */
	error?: ErrMsgJson;
};

/**
 * Describes the message identities.v1.PrehookSignupResponse.
 * Use `create(PrehookSignupResponseSchema)` to create a new message.
 */
export const PrehookSignupResponseSchema: GenMessage<PrehookSignupResponse, { jsonType: PrehookSignupResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 16);

/**
 * @generated from message identities.v1.JWTPrehookResponse
 */
export type JWTPrehookResponse = Message<"identities.v1.JWTPrehookResponse"> & {
	/**
	 * @generated from field: bool continue = 1;
	 */
	continue: boolean;

	/**
	 * @generated from field: identities.v1.ErrMsg error = 2;
	 */
	error?: ErrMsg | undefined;

	/**
	 * @generated from field: identities.v1.Response response = 3;
	 */
	response?: Response | undefined;
};

/**
 * @generated from message identities.v1.JWTPrehookResponse
 */
export type JWTPrehookResponseJson = {
	/**
	 * @generated from field: bool continue = 1;
	 */
	continue?: boolean;

	/**
	 * @generated from field: identities.v1.ErrMsg error = 2;
	 */
	error?: ErrMsgJson;

	/**
	 * @generated from field: identities.v1.Response response = 3;
	 */
	response?: ResponseJson;
};

/**
 * Describes the message identities.v1.JWTPrehookResponse.
 * Use `create(JWTPrehookResponseSchema)` to create a new message.
 */
export const JWTPrehookResponseSchema: GenMessage<JWTPrehookResponse, { jsonType: JWTPrehookResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 17);

/**
 * @generated from message identities.v1.Response
 */
export type Response = Message<"identities.v1.Response"> & {
	/**
	 * @generated from field: identities.v1.ResponseClaims claims = 1;
	 */
	claims?: ResponseClaims | undefined;
};

/**
 * @generated from message identities.v1.Response
 */
export type ResponseJson = {
	/**
	 * @generated from field: identities.v1.ResponseClaims claims = 1;
	 */
	claims?: ResponseClaimsJson;
};

/**
 * Describes the message identities.v1.Response.
 * Use `create(ResponseSchema)` to create a new message.
 */
export const ResponseSchema: GenMessage<Response, { jsonType: ResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 18);

/**
 * @generated from message identities.v1.ErrMsg
 */
export type ErrMsg = Message<"identities.v1.ErrMsg"> & {
	/**
	 * @generated from field: int32 status = 1;
	 */
	status: number;

	/**
	 * @generated from field: repeated string message = 2;
	 */
	message: string[];
};

/**
 * @generated from message identities.v1.ErrMsg
 */
export type ErrMsgJson = {
	/**
	 * @generated from field: int32 status = 1;
	 */
	status?: number;

	/**
	 * @generated from field: repeated string message = 2;
	 */
	message?: string[];
};

/**
 * Describes the message identities.v1.ErrMsg.
 * Use `create(ErrMsgSchema)` to create a new message.
 */
export const ErrMsgSchema: GenMessage<ErrMsg, { jsonType: ErrMsgJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 19);

/**
 * @generated from message identities.v1.CreateUserWebhookRequest
 */
export type CreateUserWebhookRequest = Message<"identities.v1.CreateUserWebhookRequest"> & {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey: string;

	/**
	 * @generated from field: identities.v1.WebhookContext event_context = 2;
	 */
	eventContext?: WebhookContext | undefined;

	/**
	 * @generated from field: identities.v1.FronteggUser user = 3;
	 */
	user?: FronteggUser | undefined;
};

/**
 * @generated from message identities.v1.CreateUserWebhookRequest
 */
export type CreateUserWebhookRequestJson = {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey?: string;

	/**
	 * @generated from field: identities.v1.WebhookContext event_context = 2;
	 */
	eventContext?: WebhookContextJson;

	/**
	 * @generated from field: identities.v1.FronteggUser user = 3;
	 */
	user?: FronteggUserJson;
};

/**
 * Describes the message identities.v1.CreateUserWebhookRequest.
 * Use `create(CreateUserWebhookRequestSchema)` to create a new message.
 */
export const CreateUserWebhookRequestSchema: GenMessage<CreateUserWebhookRequest, { jsonType: CreateUserWebhookRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 20);

/**
 * @generated from message identities.v1.CreateUserWebhookResponse
 */
export type CreateUserWebhookResponse = Message<"identities.v1.CreateUserWebhookResponse"> & {
	/**
	 * @generated from field: bool continue = 1;
	 */
	continue: boolean;

	/**
	 * @generated from field: identities.v1.ErrMsg error = 2;
	 */
	error?: ErrMsg | undefined;
};

/**
 * @generated from message identities.v1.CreateUserWebhookResponse
 */
export type CreateUserWebhookResponseJson = {
	/**
	 * @generated from field: bool continue = 1;
	 */
	continue?: boolean;

	/**
	 * @generated from field: identities.v1.ErrMsg error = 2;
	 */
	error?: ErrMsgJson;
};

/**
 * Describes the message identities.v1.CreateUserWebhookResponse.
 * Use `create(CreateUserWebhookResponseSchema)` to create a new message.
 */
export const CreateUserWebhookResponseSchema: GenMessage<CreateUserWebhookResponse, { jsonType: CreateUserWebhookResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 21);

/**
 * @generated from message identities.v1.FronteggRole
 */
export type FronteggRole = Message<"identities.v1.FronteggRole"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string vendor_id = 2;
	 */
	vendorId: string;

	/**
	 * @generated from field: string tenant_id = 3;
	 */
	tenantId: string;

	/**
	 * @generated from field: string key = 4;
	 */
	key: string;

	/**
	 * @generated from field: string name = 5;
	 */
	name: string;

	/**
	 * @generated from field: string description = 6;
	 */
	description: string;

	/**
	 * @generated from field: bool is_default = 7;
	 */
	isDefault: boolean;

	/**
	 * @generated from field: bool first_user_role = 8;
	 */
	firstUserRole: boolean;

	/**
	 * @generated from field: string created_at = 9;
	 */
	createdAt: string;

	/**
	 * @generated from field: string updated_at = 10;
	 */
	updatedAt: string;

	/**
	 * @generated from field: repeated string permissions = 11;
	 */
	permissions: string[];

	/**
	 * @generated from field: int32 level = 12;
	 */
	level: number;
};

/**
 * @generated from message identities.v1.FronteggRole
 */
export type FronteggRoleJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string vendor_id = 2;
	 */
	vendorId?: string;

	/**
	 * @generated from field: string tenant_id = 3;
	 */
	tenantId?: string;

	/**
	 * @generated from field: string key = 4;
	 */
	key?: string;

	/**
	 * @generated from field: string name = 5;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 6;
	 */
	description?: string;

	/**
	 * @generated from field: bool is_default = 7;
	 */
	isDefault?: boolean;

	/**
	 * @generated from field: bool first_user_role = 8;
	 */
	firstUserRole?: boolean;

	/**
	 * @generated from field: string created_at = 9;
	 */
	createdAt?: string;

	/**
	 * @generated from field: string updated_at = 10;
	 */
	updatedAt?: string;

	/**
	 * @generated from field: repeated string permissions = 11;
	 */
	permissions?: string[];

	/**
	 * @generated from field: int32 level = 12;
	 */
	level?: number;
};

/**
 * Describes the message identities.v1.FronteggRole.
 * Use `create(FronteggRoleSchema)` to create a new message.
 */
export const FronteggRoleSchema: GenMessage<FronteggRole, { jsonType: FronteggRoleJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 22);

/**
 * @generated from message identities.v1.FronteggPermission
 */
export type FronteggPermission = Message<"identities.v1.FronteggPermission"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: string created_at = 5;
	 */
	createdAt: string;

	/**
	 * @generated from field: string updated_at = 6;
	 */
	updatedAt: string;

	/**
	 * @generated from field: string category_id = 7;
	 */
	categoryId: string;

	/**
	 * @generated from field: bool fe_permission = 8;
	 */
	fePermission: boolean;

	/**
	 * @generated from field: int32 level = 9;
	 */
	level: number;
};

/**
 * @generated from message identities.v1.FronteggPermission
 */
export type FronteggPermissionJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: string created_at = 5;
	 */
	createdAt?: string;

	/**
	 * @generated from field: string updated_at = 6;
	 */
	updatedAt?: string;

	/**
	 * @generated from field: string category_id = 7;
	 */
	categoryId?: string;

	/**
	 * @generated from field: bool fe_permission = 8;
	 */
	fePermission?: boolean;

	/**
	 * @generated from field: int32 level = 9;
	 */
	level?: number;
};

/**
 * Describes the message identities.v1.FronteggPermission.
 * Use `create(FronteggPermissionSchema)` to create a new message.
 */
export const FronteggPermissionSchema: GenMessage<FronteggPermission, { jsonType: FronteggPermissionJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 23);

/**
 * @generated from message identities.v1.FronteggTenant
 */
export type FronteggTenant = Message<"identities.v1.FronteggTenant"> & {
	/**
	 * @generated from field: string tenant_id = 1;
	 */
	tenantId: string;

	/**
	 * @generated from field: repeated identities.v1.FronteggRole roles = 2;
	 */
	roles: FronteggRole[];
};

/**
 * @generated from message identities.v1.FronteggTenant
 */
export type FronteggTenantJson = {
	/**
	 * @generated from field: string tenant_id = 1;
	 */
	tenantId?: string;

	/**
	 * @generated from field: repeated identities.v1.FronteggRole roles = 2;
	 */
	roles?: FronteggRoleJson[];
};

/**
 * Describes the message identities.v1.FronteggTenant.
 * Use `create(FronteggTenantSchema)` to create a new message.
 */
export const FronteggTenantSchema: GenMessage<FronteggTenant, { jsonType: FronteggTenantJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 24);

/**
 * @generated from message identities.v1.FronteggUser
 */
export type FronteggUser = Message<"identities.v1.FronteggUser"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string sub = 2;
	 */
	sub: string;

	/**
	 * @generated from field: string email = 3;
	 */
	email: string;

	/**
	 * @generated from field: bool verified = 4;
	 */
	verified: boolean;

	/**
	 * @generated from field: bool mfa_enrolled = 5;
	 */
	mfaEnrolled: boolean;

	/**
	 * @generated from field: optional bool mfa_bypass = 6;
	 */
	mfaBypass?: boolean | undefined;

	/**
	 * @generated from field: optional string name = 7;
	 */
	name?: string | undefined;

	/**
	 * @generated from field: optional string phone_number = 8;
	 */
	phoneNumber?: string | undefined;

	/**
	 * @generated from field: optional string profile_picture_url = 9;
	 */
	profilePictureUrl?: string | undefined;

	/**
	 * @generated from field: repeated identities.v1.FronteggRole roles = 10;
	 */
	roles: FronteggRole[];

	/**
	 * @generated from field: repeated identities.v1.FronteggPermission permissions = 11;
	 */
	permissions: FronteggPermission[];

	/**
	 * @generated from field: string provider = 12;
	 */
	provider: string;

	/**
	 * @generated from field: string tenant_id = 13;
	 */
	tenantId: string;

	/**
	 * @generated from field: repeated string tenant_ids = 14;
	 */
	tenantIds: string[];

	/**
	 * @generated from field: optional bool activated_for_tenant = 15;
	 */
	activatedForTenant?: boolean | undefined;

	/**
	 * @generated from field: optional bool is_locked = 16;
	 */
	isLocked?: boolean | undefined;

	/**
	 * @generated from field: repeated identities.v1.FronteggTenant tenants = 17;
	 */
	tenants: FronteggTenant[];

	/**
	 * @generated from field: optional bool invisible = 18;
	 */
	invisible?: boolean | undefined;

	/**
	 * @generated from field: optional bool super_user = 19;
	 */
	superUser?: boolean | undefined;

	/**
	 * @generated from field: string metadata = 20;
	 */
	metadata: string;

	/**
	 * @generated from field: string created_at = 21;
	 */
	createdAt: string;

	/**
	 * @generated from field: string last_login = 22;
	 */
	lastLogin: string;

	/**
	 * @generated from field: string managed_by = 23;
	 */
	managedBy: string;

	/**
	 * @generated from field: bool sub_account_access_allowed = 24;
	 */
	subAccountAccessAllowed: boolean;

	/**
	 * @generated from field: repeated string groups = 25;
	 */
	groups: string[];
};

/**
 * @generated from message identities.v1.FronteggUser
 */
export type FronteggUserJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string sub = 2;
	 */
	sub?: string;

	/**
	 * @generated from field: string email = 3;
	 */
	email?: string;

	/**
	 * @generated from field: bool verified = 4;
	 */
	verified?: boolean;

	/**
	 * @generated from field: bool mfa_enrolled = 5;
	 */
	mfaEnrolled?: boolean;

	/**
	 * @generated from field: optional bool mfa_bypass = 6;
	 */
	mfaBypass?: boolean;

	/**
	 * @generated from field: optional string name = 7;
	 */
	name?: string;

	/**
	 * @generated from field: optional string phone_number = 8;
	 */
	phoneNumber?: string;

	/**
	 * @generated from field: optional string profile_picture_url = 9;
	 */
	profilePictureUrl?: string;

	/**
	 * @generated from field: repeated identities.v1.FronteggRole roles = 10;
	 */
	roles?: FronteggRoleJson[];

	/**
	 * @generated from field: repeated identities.v1.FronteggPermission permissions = 11;
	 */
	permissions?: FronteggPermissionJson[];

	/**
	 * @generated from field: string provider = 12;
	 */
	provider?: string;

	/**
	 * @generated from field: string tenant_id = 13;
	 */
	tenantId?: string;

	/**
	 * @generated from field: repeated string tenant_ids = 14;
	 */
	tenantIds?: string[];

	/**
	 * @generated from field: optional bool activated_for_tenant = 15;
	 */
	activatedForTenant?: boolean;

	/**
	 * @generated from field: optional bool is_locked = 16;
	 */
	isLocked?: boolean;

	/**
	 * @generated from field: repeated identities.v1.FronteggTenant tenants = 17;
	 */
	tenants?: FronteggTenantJson[];

	/**
	 * @generated from field: optional bool invisible = 18;
	 */
	invisible?: boolean;

	/**
	 * @generated from field: optional bool super_user = 19;
	 */
	superUser?: boolean;

	/**
	 * @generated from field: string metadata = 20;
	 */
	metadata?: string;

	/**
	 * @generated from field: string created_at = 21;
	 */
	createdAt?: string;

	/**
	 * @generated from field: string last_login = 22;
	 */
	lastLogin?: string;

	/**
	 * @generated from field: string managed_by = 23;
	 */
	managedBy?: string;

	/**
	 * @generated from field: bool sub_account_access_allowed = 24;
	 */
	subAccountAccessAllowed?: boolean;

	/**
	 * @generated from field: repeated string groups = 25;
	 */
	groups?: string[];
};

/**
 * Describes the message identities.v1.FronteggUser.
 * Use `create(FronteggUserSchema)` to create a new message.
 */
export const FronteggUserSchema: GenMessage<FronteggUser, { jsonType: FronteggUserJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 25);

/**
 * @generated from message identities.v1.WebhookContext
 */
export type WebhookContext = Message<"identities.v1.WebhookContext"> & {
	/**
	 * @generated from field: string tenant_id = 1;
	 */
	tenantId: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;

	/**
	 * @generated from field: string vendor_id = 3;
	 */
	vendorId: string;
};

/**
 * @generated from message identities.v1.WebhookContext
 */
export type WebhookContextJson = {
	/**
	 * @generated from field: string tenant_id = 1;
	 */
	tenantId?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;

	/**
	 * @generated from field: string vendor_id = 3;
	 */
	vendorId?: string;
};

/**
 * Describes the message identities.v1.WebhookContext.
 * Use `create(WebhookContextSchema)` to create a new message.
 */
export const WebhookContextSchema: GenMessage<WebhookContext, { jsonType: WebhookContextJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 26);

/**
 * @generated from message identities.v1.SamlMetadata
 */
export type SamlMetadata = Message<"identities.v1.SamlMetadata"> & {
	/**
	 * @generated from field: string saml_response = 1;
	 */
	samlResponse: string;

	/**
	 * @generated from field: string relay_state = 2;
	 */
	relayState: string;

	/**
	 * @generated from field: google.protobuf.Value saml_attributes = 3;
	 */
	samlAttributes?: Value | undefined;

	/**
	 * @generated from field: string sso_config_id = 4;
	 */
	ssoConfigId: string;

	/**
	 * @generated from field: string email = 5;
	 */
	email: string;

	/**
	 * @generated from field: bool is_new_user = 6;
	 */
	isNewUser: boolean;
};

/**
 * @generated from message identities.v1.SamlMetadata
 */
export type SamlMetadataJson = {
	/**
	 * @generated from field: string saml_response = 1;
	 */
	samlResponse?: string;

	/**
	 * @generated from field: string relay_state = 2;
	 */
	relayState?: string;

	/**
	 * @generated from field: google.protobuf.Value saml_attributes = 3;
	 */
	samlAttributes?: ValueJson;

	/**
	 * @generated from field: string sso_config_id = 4;
	 */
	ssoConfigId?: string;

	/**
	 * @generated from field: string email = 5;
	 */
	email?: string;

	/**
	 * @generated from field: bool is_new_user = 6;
	 */
	isNewUser?: boolean;
};

/**
 * Describes the message identities.v1.SamlMetadata.
 * Use `create(SamlMetadataSchema)` to create a new message.
 */
export const SamlMetadataSchema: GenMessage<SamlMetadata, { jsonType: SamlMetadataJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 27);

/**
 * @generated from message identities.v1.SamlUser
 */
export type SamlUser = Message<"identities.v1.SamlUser"> & {
	/**
	 * @generated from field: string first_name = 1;
	 */
	firstName: string;

	/**
	 * @generated from field: string last_name = 2;
	 */
	lastName: string;

	/**
	 * @generated from field: string email = 3;
	 */
	email: string;

	/**
	 * @generated from field: repeated string roles_ids = 4;
	 */
	rolesIds: string[];

	/**
	 * @generated from field: string metadata = 5;
	 */
	metadata: string;

	/**
	 * @generated from field: string profile_picture_url = 6;
	 */
	profilePictureUrl: string;
};

/**
 * @generated from message identities.v1.SamlUser
 */
export type SamlUserJson = {
	/**
	 * @generated from field: string first_name = 1;
	 */
	firstName?: string;

	/**
	 * @generated from field: string last_name = 2;
	 */
	lastName?: string;

	/**
	 * @generated from field: string email = 3;
	 */
	email?: string;

	/**
	 * @generated from field: repeated string roles_ids = 4;
	 */
	rolesIds?: string[];

	/**
	 * @generated from field: string metadata = 5;
	 */
	metadata?: string;

	/**
	 * @generated from field: string profile_picture_url = 6;
	 */
	profilePictureUrl?: string;
};

/**
 * Describes the message identities.v1.SamlUser.
 * Use `create(SamlUserSchema)` to create a new message.
 */
export const SamlUserSchema: GenMessage<SamlUser, { jsonType: SamlUserJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 28);

/**
 * @generated from message identities.v1.SamlResponse
 */
export type SamlResponse = Message<"identities.v1.SamlResponse"> & {
	/**
	 * @generated from field: identities.v1.SamlUser user = 1;
	 */
	user?: SamlUser | undefined;
};

/**
 * @generated from message identities.v1.SamlResponse
 */
export type SamlResponseJson = {
	/**
	 * @generated from field: identities.v1.SamlUser user = 1;
	 */
	user?: SamlUserJson;
};

/**
 * Describes the message identities.v1.SamlResponse.
 * Use `create(SamlResponseSchema)` to create a new message.
 */
export const SamlResponseSchema: GenMessage<SamlResponse, { jsonType: SamlResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 29);

/**
 * @generated from message identities.v1.AuthData
 */
export type AuthData = Message<"identities.v1.AuthData"> & {
	/**
	 * @generated from field: identities.v1.SamlMetadata saml_metadata = 1;
	 */
	samlMetadata?: SamlMetadata | undefined;
};

/**
 * @generated from message identities.v1.AuthData
 */
export type AuthDataJson = {
	/**
	 * @generated from field: identities.v1.SamlMetadata saml_metadata = 1;
	 */
	samlMetadata?: SamlMetadataJson;
};

/**
 * Describes the message identities.v1.AuthData.
 * Use `create(AuthDataSchema)` to create a new message.
 */
export const AuthDataSchema: GenMessage<AuthData, { jsonType: AuthDataJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 30);

/**
 * @generated from message identities.v1.PrehookInvitationContext
 */
export type PrehookInvitationContext = Message<"identities.v1.PrehookInvitationContext"> & {
	/**
	 * @generated from field: string vendor_id = 1;
	 */
	vendorId: string;

	/**
	 * @generated from field: string tenant_id = 2;
	 */
	tenantId: string;

	/**
	 * @generated from field: string user_id = 3;
	 */
	userId: string;
};

/**
 * @generated from message identities.v1.PrehookInvitationContext
 */
export type PrehookInvitationContextJson = {
	/**
	 * @generated from field: string vendor_id = 1;
	 */
	vendorId?: string;

	/**
	 * @generated from field: string tenant_id = 2;
	 */
	tenantId?: string;

	/**
	 * @generated from field: string user_id = 3;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.PrehookInvitationContext.
 * Use `create(PrehookInvitationContextSchema)` to create a new message.
 */
export const PrehookInvitationContextSchema: GenMessage<PrehookInvitationContext, { jsonType: PrehookInvitationContextJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 31);

/**
 * @generated from message identities.v1.InviteCreatedPrehookData
 */
export type InviteCreatedPrehookData = Message<"identities.v1.InviteCreatedPrehookData"> & {
	/**
	 * "INVITE" | "CREATE"
	 *
	 * @generated from field: string action = 1;
	 */
	action: string;

	/**
	 * @generated from field: identities.v1.InviteDataUser user = 2;
	 */
	user?: InviteDataUser | undefined;
};

/**
 * @generated from message identities.v1.InviteCreatedPrehookData
 */
export type InviteCreatedPrehookDataJson = {
	/**
	 * "INVITE" | "CREATE"
	 *
	 * @generated from field: string action = 1;
	 */
	action?: string;

	/**
	 * @generated from field: identities.v1.InviteDataUser user = 2;
	 */
	user?: InviteDataUserJson;
};

/**
 * Describes the message identities.v1.InviteCreatedPrehookData.
 * Use `create(InviteCreatedPrehookDataSchema)` to create a new message.
 */
export const InviteCreatedPrehookDataSchema: GenMessage<InviteCreatedPrehookData, { jsonType: InviteCreatedPrehookDataJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 32);

/**
 * @generated from message identities.v1.InviteDataUser
 */
export type InviteDataUser = Message<"identities.v1.InviteDataUser"> & {
	/**
	 * @generated from field: string email = 1;
	 */
	email: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string profile_picture_url = 3;
	 */
	profilePictureUrl: string;

	/**
	 * @generated from field: string phone_number = 4;
	 */
	phoneNumber: string;

	/**
	 * @generated from field: string provider = 5;
	 */
	provider: string;

	/**
	 * @generated from field: repeated string role_ids = 6;
	 */
	roleIds: string[];

	/**
	 * @generated from field: string metadata = 7;
	 */
	metadata: string;

	/**
	 * @generated from field: bool sub_account_access = 8;
	 */
	subAccountAccess: boolean;
};

/**
 * @generated from message identities.v1.InviteDataUser
 */
export type InviteDataUserJson = {
	/**
	 * @generated from field: string email = 1;
	 */
	email?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string profile_picture_url = 3;
	 */
	profilePictureUrl?: string;

	/**
	 * @generated from field: string phone_number = 4;
	 */
	phoneNumber?: string;

	/**
	 * @generated from field: string provider = 5;
	 */
	provider?: string;

	/**
	 * @generated from field: repeated string role_ids = 6;
	 */
	roleIds?: string[];

	/**
	 * @generated from field: string metadata = 7;
	 */
	metadata?: string;

	/**
	 * @generated from field: bool sub_account_access = 8;
	 */
	subAccountAccess?: boolean;
};

/**
 * Describes the message identities.v1.InviteDataUser.
 * Use `create(InviteDataUserSchema)` to create a new message.
 */
export const InviteDataUserSchema: GenMessage<InviteDataUser, { jsonType: InviteDataUserJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 33);

/**
 * @generated from message identities.v1.InviteCreatedPrehookRequest
 */
export type InviteCreatedPrehookRequest = Message<"identities.v1.InviteCreatedPrehookRequest"> & {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey: string;

	/**
	 * @generated from field: identities.v1.Context prehook_context = 2;
	 */
	prehookContext?: Context | undefined;

	/**
	 * @generated from field: identities.v1.InviteCreatedPrehookData data = 3;
	 */
	data?: InviteCreatedPrehookData | undefined;
};

/**
 * @generated from message identities.v1.InviteCreatedPrehookRequest
 */
export type InviteCreatedPrehookRequestJson = {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey?: string;

	/**
	 * @generated from field: identities.v1.Context prehook_context = 2;
	 */
	prehookContext?: ContextJson;

	/**
	 * @generated from field: identities.v1.InviteCreatedPrehookData data = 3;
	 */
	data?: InviteCreatedPrehookDataJson;
};

/**
 * Describes the message identities.v1.InviteCreatedPrehookRequest.
 * Use `create(InviteCreatedPrehookRequestSchema)` to create a new message.
 */
export const InviteCreatedPrehookRequestSchema: GenMessage<InviteCreatedPrehookRequest, { jsonType: InviteCreatedPrehookRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 34);

/**
 * @generated from message identities.v1.InviteCreatedPrehookResponse
 */
export type InviteCreatedPrehookResponse = Message<"identities.v1.InviteCreatedPrehookResponse"> & {
	/**
	 * "allow" | "block" | "challenge" | "lock"
	 *
	 * @generated from field: string verdict = 1;
	 */
	verdict: string;

	/**
	 * @generated from field: identities.v1.HookError error = 2;
	 */
	error?: HookError | undefined;
};

/**
 * @generated from message identities.v1.InviteCreatedPrehookResponse
 */
export type InviteCreatedPrehookResponseJson = {
	/**
	 * "allow" | "block" | "challenge" | "lock"
	 *
	 * @generated from field: string verdict = 1;
	 */
	verdict?: string;

	/**
	 * @generated from field: identities.v1.HookError error = 2;
	 */
	error?: HookErrorJson;
};

/**
 * Describes the message identities.v1.InviteCreatedPrehookResponse.
 * Use `create(InviteCreatedPrehookResponseSchema)` to create a new message.
 */
export const InviteCreatedPrehookResponseSchema: GenMessage<InviteCreatedPrehookResponse, { jsonType: InviteCreatedPrehookResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 35);

/**
 * @generated from message identities.v1.HookError
 */
export type HookError = Message<"identities.v1.HookError"> & {
	/**
	 * @generated from field: int32 status = 1;
	 */
	status: number;

	/**
	 * @generated from field: repeated string message = 2;
	 */
	message: string[];
};

/**
 * @generated from message identities.v1.HookError
 */
export type HookErrorJson = {
	/**
	 * @generated from field: int32 status = 1;
	 */
	status?: number;

	/**
	 * @generated from field: repeated string message = 2;
	 */
	message?: string[];
};

/**
 * Describes the message identities.v1.HookError.
 * Use `create(HookErrorSchema)` to create a new message.
 */
export const HookErrorSchema: GenMessage<HookError, { jsonType: HookErrorJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 36);

/**
 * @generated from message identities.v1.SCIMHookRequest
 */
export type SCIMHookRequest = Message<"identities.v1.SCIMHookRequest"> & {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey: string;

	/**
	 * @generated from field: identities.v1.WebhookContext event_context = 2;
	 */
	eventContext?: WebhookContext | undefined;

	/**
	 * @generated from field: string scim_config_id = 3;
	 */
	scimConfigId: string;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 4;
	 */
	metadata?: JsonObject | undefined;

	/**
	 * @generated from field: string vendor_id = 5;
	 */
	vendorId: string;

	/**
	 * @generated from field: string tenant_id = 6;
	 */
	tenantId: string;

	/**
	 * @generated from field: optional identities.v1.SCIMUser user = 7;
	 */
	user?: SCIMUser | undefined;

	/**
	 * @generated from field: optional identities.v1.SCIMGroup group = 8;
	 */
	group?: SCIMGroup | undefined;

	/**
	 * @generated from field: repeated identities.v1.SCIMGroupOperation operations = 9;
	 */
	operations: SCIMGroupOperation[];
};

/**
 * @generated from message identities.v1.SCIMHookRequest
 */
export type SCIMHookRequestJson = {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey?: string;

	/**
	 * @generated from field: identities.v1.WebhookContext event_context = 2;
	 */
	eventContext?: WebhookContextJson;

	/**
	 * @generated from field: string scim_config_id = 3;
	 */
	scimConfigId?: string;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 4;
	 */
	metadata?: StructJson;

	/**
	 * @generated from field: string vendor_id = 5;
	 */
	vendorId?: string;

	/**
	 * @generated from field: string tenant_id = 6;
	 */
	tenantId?: string;

	/**
	 * @generated from field: optional identities.v1.SCIMUser user = 7;
	 */
	user?: SCIMUserJson;

	/**
	 * @generated from field: optional identities.v1.SCIMGroup group = 8;
	 */
	group?: SCIMGroupJson;

	/**
	 * @generated from field: repeated identities.v1.SCIMGroupOperation operations = 9;
	 */
	operations?: SCIMGroupOperationJson[];
};

/**
 * Describes the message identities.v1.SCIMHookRequest.
 * Use `create(SCIMHookRequestSchema)` to create a new message.
 */
export const SCIMHookRequestSchema: GenMessage<SCIMHookRequest, { jsonType: SCIMHookRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 37);

/**
 * @generated from message identities.v1.SCIMGroupOperation
 */
export type SCIMGroupOperation = Message<"identities.v1.SCIMGroupOperation"> & {
	/**
	 * op: "Add" | "Remove" | "Replace"
	 *
	 * @generated from field: string op = 1;
	 */
	op: string;

	/**
	 * path: "members"
	 *
	 * @generated from field: string path = 2;
	 */
	path: string;

	/**
	 * @generated from field: repeated identities.v1.SCIMGroupMemberData value = 3;
	 */
	value: SCIMGroupMemberData[];
};

/**
 * @generated from message identities.v1.SCIMGroupOperation
 */
export type SCIMGroupOperationJson = {
	/**
	 * op: "Add" | "Remove" | "Replace"
	 *
	 * @generated from field: string op = 1;
	 */
	op?: string;

	/**
	 * path: "members"
	 *
	 * @generated from field: string path = 2;
	 */
	path?: string;

	/**
	 * @generated from field: repeated identities.v1.SCIMGroupMemberData value = 3;
	 */
	value?: SCIMGroupMemberDataJson[];
};

/**
 * Describes the message identities.v1.SCIMGroupOperation.
 * Use `create(SCIMGroupOperationSchema)` to create a new message.
 */
export const SCIMGroupOperationSchema: GenMessage<SCIMGroupOperation, { jsonType: SCIMGroupOperationJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 38);

/**
 * @generated from message identities.v1.SCIMGroupMemberData
 */
export type SCIMGroupMemberData = Message<"identities.v1.SCIMGroupMemberData"> & {
	/**
	 * @generated from field: string email = 1;
	 */
	email: string;

	/**
	 * @generated from field: string external_id = 2;
	 */
	externalId: string;

	/**
	 * @generated from field: string user_id = 3;
	 */
	userId: string;
};

/**
 * @generated from message identities.v1.SCIMGroupMemberData
 */
export type SCIMGroupMemberDataJson = {
	/**
	 * @generated from field: string email = 1;
	 */
	email?: string;

	/**
	 * @generated from field: string external_id = 2;
	 */
	externalId?: string;

	/**
	 * @generated from field: string user_id = 3;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.SCIMGroupMemberData.
 * Use `create(SCIMGroupMemberDataSchema)` to create a new message.
 */
export const SCIMGroupMemberDataSchema: GenMessage<SCIMGroupMemberData, { jsonType: SCIMGroupMemberDataJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 39);

/**
 * @generated from message identities.v1.SCIMHookResponse
 */
export type SCIMHookResponse = Message<"identities.v1.SCIMHookResponse"> & {};

/**
 * @generated from message identities.v1.SCIMHookResponse
 */
export type SCIMHookResponseJson = {};

/**
 * Describes the message identities.v1.SCIMHookResponse.
 * Use `create(SCIMHookResponseSchema)` to create a new message.
 */
export const SCIMHookResponseSchema: GenMessage<SCIMHookResponse, { jsonType: SCIMHookResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 40);

/**
 * @generated from message identities.v1.SCIMUser
 */
export type SCIMUser = Message<"identities.v1.SCIMUser"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email: string;

	/**
	 * @generated from field: string created_at = 3;
	 */
	createdAt: string;

	/**
	 * @generated from field: optional string name = 4;
	 */
	name?: string | undefined;

	/**
	 * @generated from field: string provider = 5;
	 */
	provider: string;

	/**
	 * @generated from field: optional string external_id = 6;
	 */
	externalId?: string | undefined;

	/**
	 * @generated from field: bool is_locked = 7;
	 */
	isLocked: boolean;
};

/**
 * @generated from message identities.v1.SCIMUser
 */
export type SCIMUserJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;

	/**
	 * @generated from field: string created_at = 3;
	 */
	createdAt?: string;

	/**
	 * @generated from field: optional string name = 4;
	 */
	name?: string;

	/**
	 * @generated from field: string provider = 5;
	 */
	provider?: string;

	/**
	 * @generated from field: optional string external_id = 6;
	 */
	externalId?: string;

	/**
	 * @generated from field: bool is_locked = 7;
	 */
	isLocked?: boolean;
};

/**
 * Describes the message identities.v1.SCIMUser.
 * Use `create(SCIMUserSchema)` to create a new message.
 */
export const SCIMUserSchema: GenMessage<SCIMUser, { jsonType: SCIMUserJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 41);

/**
 * @generated from message identities.v1.SCIMGroup
 */
export type SCIMGroup = Message<"identities.v1.SCIMGroup"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: optional string external_id = 3;
	 */
	externalId?: string | undefined;
};

/**
 * @generated from message identities.v1.SCIMGroup
 */
export type SCIMGroupJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: optional string external_id = 3;
	 */
	externalId?: string;
};

/**
 * Describes the message identities.v1.SCIMGroup.
 * Use `create(SCIMGroupSchema)` to create a new message.
 */
export const SCIMGroupSchema: GenMessage<SCIMGroup, { jsonType: SCIMGroupJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_frontegg, 42);
